import React from 'react';
import { Modal, ModalDialog, ModalClose, Box, Typography } from '@mui/joy';
import { Backdrop } from '@mui/joy';
import FenceLinkNameLogo from '../../assets/icons/name-logo/Component 1.svg';

const OverrideDialog = ({ 
  open, 
  onClose, 
  title, 
  children, 
  maxWidth = 'sm',
  disableBackdropClick = false,
  showCloseButton = true 
}) => {
  const handleBackdropClick = (event) => {
    // Prevent closing if disableBackdropClick is true
    if (disableBackdropClick) {
      event.stopPropagation();
      return;
    }
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={!disableBackdropClick ? onClose : undefined}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backdropFilter: 'blur(8px)',
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      }}
      slotProps={{
        backdrop: {
          onClick: handleBackdropClick,
          sx: {
            backdropFilter: 'blur(8px)',
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
          }
        }
      }}
    >
      <ModalDialog
        variant="outlined"
        size={maxWidth}
        sx={{
          maxWidth: maxWidth === 'xs' ? 400 : maxWidth === 'sm' ? 500 : maxWidth === 'md' ? 600 : maxWidth === 'lg' ? 800 : maxWidth,
          width: '90vw',
          maxHeight: '90vh',
          overflow: 'auto',
          borderRadius: 'lg',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
          border: '1px solid',
          borderColor: 'divider',
          backgroundColor: 'background.surface',
        }}
      >
        {/* Close button */}
        {showCloseButton && !disableBackdropClick && (
          <ModalClose
            variant="plain"
            sx={{
              position: 'absolute',
              top: 16,
              right: 16,
              zIndex: 1,
              borderRadius: '50%',
              backgroundColor: 'background.level1',
              '&:hover': {
                backgroundColor: 'background.level2',
              }
            }}
            onClick={onClose}
          />
        )}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            mb: 2,
          }}
        >

                  <img 
                    src={FenceLinkNameLogo} 
                    alt={`fenceLink logo`}
                    style={{ width: 140, height: 'auto' }}
                  />
        </Box>

        {/* Title */}
        {title && (
          <Box sx={{ mb: 2, pr: showCloseButton ? 4 : 0 }}>
            <Typography level="h4" component="h2">
              {title}
            </Typography>
          </Box>
        )}

        {/* Content */}
        <Box sx={{ width: '100%' }}>
          {children}
        </Box>
      </ModalDialog>
    </Modal>
  );
};

export default OverrideDialog;